<template>
    <v-col md="6"><v-card flat :loading="profile.sendMails" :key="profile._id" class="mt-3">
            <v-card flat class="mx-auto pa-3">
                <v-row>
                    <v-col cols='11'>
                        <v-card-text>
                            <p class="display-1 text--primary">
                                {{ profile.fullName }} ({{ profile.abbreviation }})
                            </p>
                            <p></p>
                            <div class="text--primary">
                                Количество мест для регистрации:
                                {{ profile.quantity }}
                            </div>
                            <div class="text--primary">
                                Количество зарегистрированных:
                                {{ profile.index - 1 }}
                            </div>
                            <div class="text--primary">
                                Подтверждено:
                                {{ confirmedCounter }}
                            </div>
                            <div class="text--primary">
                                Удалено:
                                {{ deletedCounter }}
                            </div>
                            <div class="text--primary">
                                Приглашено:
                                {{ invitedCounter }}
                            </div>
                        </v-card-text>
                    </v-col>
                    <v-col cols='1'>
                        <v-icon @click="downloadList(newList._id)">mdi-file-download</v-icon>
                    </v-col>
                    <v-card-actions class="flex px-5 justify-center">
                    </v-card-actions>
                </v-row>
                <v-card-actions class="flex justify-space-between">
                    <div class="d-flex">
                        <ProfileSettings :profile="newList" />
                        <Mailings :loadProfiles="loadProfiles" :profile="newList" />
                    </div>
                     <div>
                        <v-btn color="error" dark @click="doDelete" text>
                            Удалить
                        </v-btn>
                    </div>
                </v-card-actions>
                
            </v-card> </v-card><confirm-dialogue ref="confirmDialogue"></confirm-dialogue></v-col>
</template>
<script>

import ConfirmDialogue from '../helpers/ConfirmDialogue.vue'
import ProfileSettings from './profileSettings.vue'
import Mailings from './Mailings.vue'
export default {
    data() {
        return {
            profiles: {},
            dialog: false
        }
    },
    components: {
        ConfirmDialogue,
        ProfileSettings,
        Mailings
    },
    props: {
        profile: {
            type: Object,
            default() {
                return {}
            },
        },
        loadProfiles: {
            type: Function
        },
        registries: {
            type: Object
        }
    },
    computed: {
        newList: function () {
            return (this.profiles = Object.assign(this.profiles, this.profile))
        },
        confirmedCounter: function () {
            return this.registries.confirmed.filter((item) => item.profile == this.profile.enrolleePrefix).length
        },
        deletedCounter: function () {
            return this.registries.deleted.filter((item) => item.profile == this.profile.enrolleePrefix).length
        },
        invitedCounter: function () {
            return this.registries.invited.filter((item) => item.profile == this.profile.enrolleePrefix).length
        }
    },
    methods: {
        async doDelete() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите удалить профиль?',
                okButton: 'Удалить',
            })
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.$axios
                    .post('/api/delete-profile/', {
                        _id: this.newList._id,
                    })
                    .then((data) => {
                        console.log(data);
                        if (data.data.answer == 'success') {
                            this.$notify({
                                text: data.data.text
                            });
                        } else {
                            this.$notify({
                                type: 'error',
                                text: data.data.text
                            });
                        }
                        this.$emit('destroy', this.newList._id)
                    })
            }
        },
        async downloadList(id) {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Вы уверены, что хотите выгрузить данные по профилю?',
                okButton: 'Начать',
            })
            if (ok) {
                this.$axios
                    .post(
                        '/api/downloadList/',
                        {
                            _id: id,
                        },
                        { responseType: 'arraybuffer' }
                    )
                    .then((data) => {
                        var fileURL = window.URL.createObjectURL(
                            new Blob([data.data], {
                                type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
                            })
                        )
                        var fileLink = document.createElement('a')
                        fileLink.href = fileURL
                        fileLink.setAttribute(
                            'download',
                            `${id}-${new Date().toLocaleString('ru-RU')}.xlsx`
                        )
                        document.body.appendChild(fileLink)
                        fileLink.click()
                        this.$notify({
                            text: 'Файл загружается'
                        });
                    })
            }
        }
    },
}
</script>
<style>
.v-input__slot .v-label {
    color: black !important;
}
</style>